import { all, takeLatest } from 'redux-saga/effects';

import {
  authUser as authUserAction,
  loginFromCode as loginFromCodeAction,
  loginFromCookie as loginFromCookieAction,
  loginFromUrl as loginFromUrlAction,
  sendAuthParams as sendAuthParamsAction,
  startRefreshCountdown,
} from '../authUserSlice';
import {
  authUser,
  loginFromCode,
  loginFromCookie,
  loginFromUrl,
  sendAuthParams,
} from './logInSagas';
import { refreshCountdown } from './refreshTokenCountdown';

export function* watchAuth() {
  yield all([
    takeLatest(authUserAction.type, authUser),
    takeLatest(loginFromUrlAction.type, loginFromUrl),
    takeLatest(loginFromCookieAction.type, loginFromCookie),
    takeLatest(startRefreshCountdown.type, refreshCountdown),
    takeLatest(sendAuthParamsAction.type, sendAuthParams),
    takeLatest(loginFromCodeAction.type, loginFromCode),
  ]);
}
